import { IHttpService } from "../HttpService";
import EvaluationType, {
  IEvaluationType
} from "../../model/evaluation/EvaluationType";
import EvaluationTypeRuleGroup, {
  IEvaluationTypeRuleGroup
} from "../../model/evaluation/EvaluationTypeRuleGroup";

export interface IEvaluationTypeService {
  getEvaluationTypes(): Promise<IEvaluationType[]>;
  createEvaluationType(evaluation: IEvaluationType): Promise<any>;
  updateEvaluationType(evaluation: IEvaluationType): void;
  getRuleGroupsForEvaluationType(
    evaluation: IEvaluationType
  ): Promise<IEvaluationTypeRuleGroup[]>;
  joinRuleGroupToEvaluationType(
    evaluationId: number,
    ruleGroupId: number
  ): Promise<any>;
  releaseRuleGroup(evaluationTypeRuleGroupId: number): Promise<any>;
}

const EvaluationTypeService = (httpService): IEvaluationTypeService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api/";
  const _basePath = "evaluation-types";
  const _ruleGroupsPath = "/rule-groups";
  const _ruleGroupPath = "/rule-group";

  const EvaluationTypeMapper = (json = []) => {
    return json.map(EvaluationType);
  };

  const EvaluationTypeListRuleGroupMapper = (json = []) => {
    return json.map((item: any) => {
      return EvaluationTypeRuleGroup(item);
    });
  };

  return {
    async getEvaluationTypes() {
      const path = _http.buildPath(_baseUrl, _basePath);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return EvaluationTypeMapper(responseJSON);
    },

    async createEvaluationType(evaluation: IEvaluationType) {
      const path = _http.buildPath(_baseUrl, _basePath);
      const response = await _http.post(path, {
        params: evaluation,
        form: true
      });
      return _http.toText(response);
    },

    async updateEvaluationType(evaluation: IEvaluationType) {
      const path = _http.buildPath(
        _baseUrl,
        _basePath,
        evaluation.id.toString()
      );
      const response = await _http.put(path, {
        params: evaluation,
        form: true
      });
      return _http.toText(response);
    },

    async getRuleGroupsForEvaluationType(evaluation: IEvaluationType) {
      const path = _http.buildPath(
        _baseUrl,
        _basePath,
        evaluation.id.toString(),
        _ruleGroupsPath
      );
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return EvaluationTypeListRuleGroupMapper(responseJSON);
    },

    async joinRuleGroupToEvaluationType(
      evaluationTypeId: number,
      ruleGroupId: number
    ) {
      const path = _http.buildPath(
        _baseUrl,
        _basePath,
        evaluationTypeId.toString(),
        _ruleGroupPath,
        ruleGroupId.toString()
      );
      const response = await _http.post(path);
      return _http.toText(response);
    },

    async releaseRuleGroup(evaluationTypeRuleGroupId: number) {
      const path = _http.buildPath(
        _baseUrl,
        _basePath,
        _ruleGroupPath,
        evaluationTypeRuleGroupId.toString()
      );
      const response = await _http.remove(path);
      return _http.toText(response);
    }
  };
};

export default EvaluationTypeService;
